import { z } from "zod";

export const pagesSearchSchema = z.object({
  page: z.coerce.number<number>().int().positive().optional().catch(1),
  status: z.enum(["published", "draft"]).optional().catch(undefined),
  query: z.string().optional().catch(undefined),
  query_operator: z
    .enum(["contains", "does_not_contain", "is", "is_not"])
    .optional()
    .catch(undefined),
  page_slug: z.string().optional().catch(undefined),
  page_slug_operator: z
    .enum(["contains", "does_not_contain", "is", "is_not"])
    .optional()
    .catch(undefined),
  access_type: z
    .enum(["open_access", "members_access", "access_group_access"])
    .optional()
    .catch(undefined),
  kind: z.enum(["custom", "system"]).optional().catch(undefined),
  order: z
    .record(z.string(), z.enum(["asc", "desc"]))
    .optional()
    .catch(undefined),
});

export type PagesSearch = z.infer<typeof pagesSearchSchema>;
